import { CheckCircleFilled } from '@finn/design-system/icons/check-circle-filled';
import { YesNoNo } from '@finn/design-system/icons/yes-no-no';
import { parseToHtml } from '@finn/ui-utils';
import { ReactNode } from 'react';

type ProsAndConsProps = {
  prostitle?: string;
  constitle?: string;
  pros?: string[];
  cons?: string[];
};

const List = ({
  title,
  icon,
  items,
}: {
  title?: string;
  items: string[];
  icon: ReactNode;
}) => (
  <div className="flex flex-col gap-4">
    <p className="body-14-semibold">{parseToHtml(title)}</p>
    {items?.length ? (
      <ul className="m-0 flex list-none flex-col gap-4 p-0">
        {items?.map((item) => (
          <li
            key={item}
            className="flex items-center gap-2 body-14-light before:hidden after:hidden"
          >
            {icon}
            {parseToHtml(item)}
          </li>
        ))}
      </ul>
    ) : null}
  </div>
);

export const ProsAndCons = ({
  prostitle,
  constitle,
  pros = [],
  cons = [],
}: ProsAndConsProps) => {
  return (
    <div className="container mx-auto grid gap-14 rounded bg-snow px-4 py-6 sm:w-[calc(100%-2rem)] md:w-[calc(100%-1rem)] md:max-w-[726px] md:grid-cols-2 md:px-6">
      <List
        title={prostitle}
        items={pros}
        icon={<CheckCircleFilled className="size-4" />}
      />
      <List
        title={constitle}
        items={cons}
        icon={<YesNoNo className="size-4" />}
      />
    </div>
  );
};
